import React from 'react'
import notifications from "../../../../assets/icons/notifications.svg"
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { IonImg } from '@ionic/react';
import { IoSyncSharp } from "react-icons/io5";
import { useAppData } from '../../../../context/appContext';
import { useHistory } from 'react-router';
import "./patientcard.css"


const Patientcard = (props) => {
    const appData = useAppData()
    const history = useHistory()

    // Navigate to messages page with patient selected
    const handleMessagesClick = (e) => {
        e.stopPropagation(); // Prevent card click
        appData.setAppUserData(props.patientData);
        appData.setSelected("Messages");
        history.push(`/dashboard/messages`);
    };

    // Navigate to symptoms/patientlog page with patient selected
    const handleSymptomsClick = (e) => {
        e.stopPropagation(); // Prevent card click
        appData.setAppUserData(props.patientData);
        appData.setSelected("Patient Log");
        history.push(`/dashboard/patientlog`);
    };

    // Navigate to data sync (for rest of card)
    const handleDataSync = (e) => {
        appData.setAppUserData(props.patientData)
        appData.setSelected("Data Sync")
        history.push(`/dashboard/datasync`)
    }


    return (
        <div
            data-testid={`TPATIENTCARD_${props.subjectId}`}
            onClick={handleDataSync}
            className='patientcard_container'
        >
            <div className="patientcard_header" >
                <div data-testid="TSUBJECTID" style={{paddingLeft:"20px"}} className='patient_subjectId'>
                    {props.subjectId}
                </div>
{/*                 <div style={{paddingRight:"20px"}} className='patient_subjectId'>
                    HCA Healthcare Nashville
                </div> */}
            </div>
            <div className='patientcard_details_container'>
                <div style={{paddingTop:"5px"}}>
                    <div  className='patientcard_detail_header'> LAST SYNC</div>
                    <div data-testid="TSYNCDAY" style={{color:"#525252"}} className='patientcard_day'>{props?.day}</div>
                    <div data-testid="TSYNCMON" style={{color:"#525252"}} className='patientcard_month'>{props?.month}</div>
                    <div style={{display:"flex",justifyContent:'center',paddingLeft:"10px",paddingBottom:"5px"}}>
                        <IoSyncSharp style={{color:"#22BCBD"}} className='patientcard_sync_icon' />
            
                    </div>
                </div>
                <div style={{ height: "100%", width: "0.5px", color: "red", backgroundColor: "#B3B3B3" }}>

                </div>
                <div style={{paddingTop:"5px"}}>
                    <div className='patientcard_detail_header'>DEVICE</div>
                    <div style={{ display: "flex", paddingTop: "11px" }}>
                        <div data-testid="TSYNCBATTLIFE" style={{ width: "60px", paddingTop: '5px', display: "flex", flexDirection: "column", alignItems: "center" }}>
                            <div style={{ fontSize: "11px", fontWeight: "500", color: "#808080", whiteSpace: "nowrap", paddingBottom: "4px" }}>BATTERY</div>
                            <CircularProgressbar
                                value={props.batteryLife || ''} text={`${props.batteryLife || ''}%`}
                                styles={buildStyles({
                                    textColor: "#22BCBD",
                                    textSize: "25px",
                                    pathColor: "#22BCBD",
                                })} /></div>
                        <div style={{ paddingLeft: "10px", paddingTop: "5px", display: "flex", flexDirection: "column", gap: "6px" }}>
                            <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                                <div style={{ fontSize: "11px", fontWeight: "500", color: "#808080", whiteSpace: "nowrap" }}>IMPLANT</div>
                                <div data-testid="TSYNCIMPLANTDATE" style={{ fontSize: "11px", fontWeight: "400", color: "#525252", whiteSpace: "nowrap" }}>{props?.implantDate}</div>
                            </div>
                            <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                                <div style={{ fontSize: "11px", fontWeight: "500", color: "#808080", whiteSpace: "nowrap" }}>RRI</div>
                                <div data-testid="TSYNCRRIDATE" style={{ fontSize: "11px", fontWeight: "400", color: "#525252", whiteSpace: "nowrap" }}>{props?.rriDate}</div>
                            </div>
                            <div style={{ display: "flex", alignItems: "baseline", gap: "4px" }}>
                                <div style={{ fontSize: "11px", fontWeight: "500", color: "#808080", whiteSpace: "nowrap" }}>EOS</div>
                                <div data-testid="TSYNCEOSDATE" style={{ fontSize: "11px", fontWeight: "400", color: "#525252", whiteSpace: "nowrap" }}>{props?.eosDate}</div>
                            </div>
                        </div>
                    </div>

                </div>
                <div style={{ height: "100%", width: "0.5px", color: "red", backgroundColor: "#B3B3B3" }}>

                </div>
                <div style={{paddingTop:"5px"}} className='patientcard_notification_container'>
                    <div className='patientcard_detail_header'>
                        NOTIFICATIONS
                    </div>
                    {/* 2x2 Grid Layout for Icons */}
                    <div style={{ 
                        display: 'grid', 
                        gridTemplateColumns: '1fr 1fr', 
                        gridTemplateRows: '1fr 1fr',
                        gap: '8px',
                        paddingTop: '8px'
                    }}>
                        {/* Top Left: Messages Icon */}
                        <div 
                            className='patientcard_icon_container' 
                            data-testid={`TPATIENTCARD_MESSAGES_${props.subjectId}`}
                            onClick={handleMessagesClick}
                            style={{ cursor: 'pointer', position: 'relative' }}
                            title="Messages"
                        >
                            <IonImg className='patientcard_notification_icon' src={notifications} alt="notifications" />
                        </div>
                        
                        {/* Top Right: Symptoms Icon */}
                        <div 
                            className='patientcard_icon_container' 
                            data-testid={`TPATIENTCARD_SYMPTOMS_${props.subjectId}`}
                            onClick={handleSymptomsClick}
                            style={{ cursor: 'pointer', position: 'relative' }}
                            title="Symptoms"
                        >
                            <IonImg 
                                className='patientcard_notification_icon' 
                                src={notifications} 
                                alt="symptoms" 
                                style={{ 
                                    filter: 'brightness(0) saturate(100%) invert(68%) sepia(64%) saturate(1234%) hue-rotate(141deg) brightness(95%) contrast(85%)',
                                    WebkitFilter: 'brightness(0) saturate(100%) invert(68%) sepia(64%) saturate(1234%) hue-rotate(141deg) brightness(95%) contrast(85%)'
                                }}
                            />
                            {/* Badge count for symptoms - only show for selected patient */}
                            {props.symptomCount > 0 && (
                                <span 
                                    aria-label={`${props.symptomCount} ${props.symptomCount === 1 ? 'symptom' : 'symptoms'}`}
                                    role="status"
                                    style={{
                                        position: "absolute",
                                        top: "-5px",
                                        right: "-5px",
                                        backgroundColor: "#f44336",
                                        color: "white",
                                        borderRadius: "50%",
                                        width: "20px",
                                        height: "20px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        border: "2px solid white"
                                    }}
                                >
                                    {props.symptomCount > 99 ? "99+" : props.symptomCount}
                                </span>
                            )}
                        </div>
                        
                        {/* Bottom Left: Data Sync Icon */}
                        <div 
                            className='patientcard_icon_container' 
                            data-testid={`TPATIENTCARD_DATASYNC_${props.subjectId}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleDataSync(e);
                            }}
                            style={{ cursor: 'pointer' }}
                            title="Data Sync"
                        >
                            <IoSyncSharp style={{color:"#22BCBD"}} className='patientcard_sync_icon' />
                        </div>
                        
                        {/* Bottom Right: Empty/Unused */}
                        <div className='patientcard_icon_container' style={{ cursor: 'default' }}>
                            <div className='patientcard_indicator'></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Patientcard
